/**
 * Asserts that a code path is unreachable. Used as the `default` case in
 * exhaustive `switch` statements to produce a compile-time error when a
 * discriminant union or enum gains a new member without a matching `case`.
 *
 * @param value - The value that should be of type `never` at compile time.
 *                Logged in the runtime error message if reached despite the type guard.
 *
 * @example
 * enum Status { Active, Inactive }
 *
 * function handleStatus(status: Status): string {
 *   switch (status) {
 *     case Status.Active:
 *       return 'active';
 *     case Status.Inactive:
 *       return 'inactive';
 *     default:
 *       return unreachable(status);
 *       // Adding a new enum value without a case → TS compile error here
 *   }
 * }
 */
export function unreachable(value: never): never {
  throw new Error(`Unreachable: ${value}`);
}
